const mime_types = {

};


export const uploads = {

    prefix(){
        return process.env.MIX_ASSET_URL.toString() + '/';
    },

    url(path){
        return `${uploads.prefix()}${path}`;
    },

    /**
     *
     * @param path
     * @param {number|object|{w: 100, h:100, c: true}} options
     * @returns {string|null}
     */
    image(path, options){

        if( !path ) return null;

        if( typeof options === 'number' ){
            options = {
                w: options,
                h: options,
                c: true,
            };
        }

        options = _.extend({
            w: 100,
            h: 100,
            c: true,
        }, options);

        const method = options.c ? 'crop' : 'resize';

        path = encodeURIComponent(path);

        return `/img/${method}/w${options.w}/h${options.h}/${path}`;
    },

    type(mime){

    }

};


export default {

    computed: {
        uploads(){
            return uploads;
        }
    }

}
